import styled, { css,keyframes } from 'styled-components'

const shineAnimation = keyframes`
  0% {
    left: -50%;
  }

  100% {
    left: 150%;
  }
`;
const customProps = new Set([
  'gradientButton',
  'header',
  'lineHeight',
  'borderRadius',
  'flexShrink',
  'alignItems',
  'justifyContent',
  'boxShadow',
  'hoverEffect',
  'width',
  'height',
  'background',
  'color',
  'padding',
  'border',
  'cursor',
  'fontSize',
  'size',
  'fontWeight',
  'marginTop',
  'marginBottom',
  'margin',
  'display',
  'borderStyle',
  'marginLeft',
  'marginRight',
  'opacity',
  'gap',
  'maxWidth',
  'textDecoration',
  'position',
  'bottom'
])

export const StyledButton = styled.button.withConfig({
  shouldForwardProp: (prop) => !customProps.has(prop)
})`
  width: ${(props) => props.width || ''};
  height: ${(props) => props.height || ''};
  background-color: ${(props) => props.background || props.theme.colors.Blue};
  color: ${(props) => props.color || props.theme.colors.White};
  padding: ${(props) => props.padding || '10px 24px'};
  border-radius: ${(props) => props.borderRadius || '100px'};
  border: ${(props) => props.border || 'none'};
  cursor: ${(props) =>
    props.cursor || (props.disabled ? 'not-allowed' : 'pointer')};
  font-size: ${(props) => props.fontSize || props.size || '16px'};
  font-weight: ${(props) =>
    props.fontWeight || props.theme.fonts.fontWeight.FW600};
  line-height: ${(props) => props.lineHeight || 'normal'};
  margin-top: ${(props) => props.marginTop || ''};
  margin-bottom: ${(props) => props.marginBottom || ''};
  margin: ${(props) => props.margin || ''};
  display: ${(props) => props.display || ''};
  justify-content: ${(props) => props.justifyContent || ''};
  border-style: ${(props) => props.borderStyle || ''};
  // &:hover {
  //     background-color: ${(props) => props.theme.colors.Blue};
  // }
  margin-left: ${(props) => props.marginLeft || ''};
  margin-right: ${(props) => props.marginRight || ''};

  opacity: ${(props) =>
    props.opacity !== undefined ? props.opacity : props.disabled ? 0.4 : 1};
  transition:
    background 0.2s,
    color 0.2s,
    opacity 0.2s;
  align-items: ${(props) => props.alignItems || 'center'};
  gap: ${(props) => props.gap || '8px'};
  max-width: ${(props) => props.maxWidth || ''};
  text-decoration: ${(props) => props.textDecoration || ''};
  position: ${(props) => props.position || ''};
  bottom: ${(props) => props.bottom || ''};

${({ hoverEffect }) =>
  hoverEffect &&
  css`
    transition:
      background 0.2s,
      color 0.2s,
      opacity 0.2s,
      filter 0.2s,
      box-shadow 0.2s;

    &:hover {
      filter: brightness(1.05);
      box-shadow: 0 10px 15px rgba(0, 0, 0, 0.15);
    }

    &:active {
      filter: brightness(0.95);
    }
  `}
  
${({ gradientButton, header }) =>
  gradientButton &&
  css`
    position: relative;
    overflow: hidden;
    isolation: isolate;

    background: linear-gradient(90deg, #84CC16 0%, #00B8F8 100%);

    ${header &&
    css`
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -50%;
        width: 35%;
        height: 100%;

        background: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0.25) 30%,
          rgba(255, 255, 255, 1) 50%,
          rgba(255, 255, 255, 0.25) 70%,
          rgba(255, 255, 255, 0) 100%
        );

        transform: skewX(-25deg);
        animation: ${shineAnimation} 2.5s linear infinite;
        pointer-events: none;
        z-index: 1;
      }

      > * {
        position: relative;
        z-index: 2;
      }
    `}
  `}
`
